import { useQuery } from "react-query";
import endpoints from "./EndPoints";
import { getNewsListFitler } from "./Services";



export const useGetNews= (filter:any) => {
  return useQuery(
    [endpoints.getNewsListFilter,filter],
    () => getNewsListFitler(filter),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
    }
  );
};
